import * as React from 'react';
import Wrapper from './Wrapper';

const Align = Wrapper(props => (
  <svg
    width={38}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.5 5.999h14M6.5 8.999h12M6.5 11.999h15M6.5 14.999h12M6.5 17.999h14M31 10.667l-2.859 2.94a.197.197 0 0 1-.282 0L25 10.666"
      stroke="#535B64"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export default Align;
